export default __webpack_public_path__ + "static/media/loppumusiikki_voitto.7010182d.mp3";